module.exports = __webpack_public_path__ + "assets/img/inboxGift.a887c084.png";